import { MessageInput, useChannelStateContext, Window } from 'stream-chat-react';

import { useChatClient } from '@bizzabo/chat-core';
import { useProfileIdByChatId } from '@bizzabo/entities';

import CustomMessageInput from '../CustomMessageInput';
import CustomMessageList from '../CustomMessageList';
import ChannelHeader from '../ChannelHeader';
import useChannelStatus from '../../../hooks/useChannelStatus';
import { extractChatPartner } from '../../../utils/helpers';
import { useMessages } from '../../../contexts/MessagesContext';
import useTypeTracking from '../../../../../analytics';
import useIsGuestOnline from './useIsGuestOnline';

const ChannelPage: React.FC = () => {
    const { channelStatus, startMeetingIndex } = useChannelStatus();
    const { channel } = useChannelStateContext();
    const { client } = useChatClient();
    const { eventId } = useMessages();
    const guestUser = extractChatPartner(channel, client);
    const { data: guestProfileId } = useProfileIdByChatId({
        chatId: guestUser?.id,
        eventId,
        options: { enabled: true },
    });
    const isGuestOnline = useIsGuestOnline();

    const { Track } = useTypeTracking({
        data: {
            description: {
                channel_id: channel.id,
                reciever_id: guestProfileId,
                reciever_status: isGuestOnline,
                location: 'ATTENDEE_CHAT',
            },
        },
    });

    return (
        <Track>
            <Window>
                <ChannelHeader
                    channelStatus={channelStatus}
                    guestUser={guestUser}
                    guestProfileId={guestProfileId}
                />
                <CustomMessageList
                    channelStatus={channelStatus}
                    startMeetingIndex={startMeetingIndex}
                    guestUser={guestUser}
                    guestProfileId={guestProfileId}
                />
                <MessageInput Input={CustomMessageInput} />
            </Window>
        </Track>
    );
};

export default ChannelPage;
